"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const percentages = {
    0: NaN,
    2: 50,
    3: 40,
    4: 25,
    5: 20,
    10: 10,
    12: 9,
    15: 7,
    20: 5,
    25: 4,
    34: 3,
    50: 2,
};
exports.default = percentages;
